import { Link } from "react-router-dom";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/music", label: "Music" },
  { to: "/videos", label: "Videos" },
  { to: "/performances", label: "Performances" },
  { to: "/booking", label: "Booking" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/[0.06] bg-charcoal-900/40">
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-serif text-3xl font-light text-sand-bright">Derrick Hall</p>
          <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
            Singer • Inspirational Vocalist • Intimate Live Music
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
          {LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              data-testid={`footer-link-${label.toLowerCase()}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-mist transition-colors duration-300 hover:text-gold"
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-14 border-t border-white/[0.06] pt-8">
        <p className="text-xs text-mist">© {new Date().getFullYear()} Derrick Hall. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
